import React from 'react';

import Button from "components/CustomButtons/Button.jsx";

import withStyles from "@material-ui/core/styles/withStyles";

import CustomInput from "components/CustomInput/CustomInput.jsx";

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InputAdornment from "@material-ui/core/InputAdornment";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import ReactSelect from 'components/Select/ReactSelect';
import { Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress } from '@material-ui/core';
import VpnKey from '@material-ui/icons/VpnKey';
import EmailEndpoints from '../../../api/EmailEndpoints';
import Api from '../../../api/Api.js';
import MonitorEndpoints from '../../../api/MonitorEndpoints';
import ImageEndpoints from '../../../api/ImageEndpoints';
import PictureUpload from '../../../components/CustomUpload/PictureUpload';
import { androidBase64 } from '../../../variables/dataIcons';

const googleAppIdRegex = /^com\.[a-zA-Z][a-zA-Z0-9_]{0,}(\.[a-zA-Z][a-zA-Z0-9_]{0,})?(\.[a-zA-Z][a-zA-Z0-9_]{0,})?$/

const verifyEmail = (value) => {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
        return true;
    }
    return false;
}

const style = {
    infoText: {
        fontWeight: "300",
        margin: "10px 0 30px",
        textAlign: "center"
    },
    inputAdornmentIcon: {
        color: "#555"
    },
    inputAdornment: {
        position: "relative"
    }
};

class AddAndroidAppDialog extends React.Component {

    state = {
        loading: false,
        emails: []
    }

    componentDidMount() {
        Api.get(EmailEndpoints.list)
            .then(({ data }) => this.setState({ emails: data }))
            .catch((e) => {
                console.error(e);
            })
    }

    submit() {
        if (this.props.bundle_identifier && googleAppIdRegex.test(this.props.bundle_identifier) && this.props.app_name) {
            this.setState({ loading: true },
                () => {
                    Api.post(MonitorEndpoints.addGooglePlayApp, { ...this.props, email_apps: this.props.email_apps.map(email => ({ email_id: email.value, app_id: this.props.bundle_identifier })) })
                        .then(({ data }) => {
                            this.setState({ loading: false }, () => {
                                this.props.onSubmit(data);
                                this.props.onClose();
                            })
                        })
                        .catch((e) => {
                            this.setState({ loading: false }, () => {
                                console.error(e);
                            });
                        })
                }
            );
        }
    }

    onChangeText(name, event) {
        this.props.onChange({ [name]: event.target.value });
    }

    onChangeSelect(name, value) {
        this.props.onChange({ [name]: value });
    }

    uploadAppIcon(file) {
        Api.fileUpload(ImageEndpoints.upload, [file], { bind: "android_app" })
            .then(({ data }) => this.props.onChange(data))
    }

    render() {

        const { classes } = this.props;

        return (
            <Dialog
                open={this.props.isOpen}
                onClose={this.props.onClose}
                fullWidth
                maxWidth="sm"
                aria-labelledby="form-dialog-title"
                PaperProps={{ style: { overflow: 'visible' } }}
            >
                <DialogTitle id="form-dialog-title">Add Android App</DialogTitle>
                <DialogContent style={{ overflow: 'visible' }}>
                    <GridContainer justify="center">
                        <GridItem xs={12}>
                            <PictureUpload
                                style={{ height: 130, width: 130, borderRadius: 4, backgroundColor: '#f7f7f7', boxShadow: '0px 5px 20px -6px rgba(0,0,0,0.35)' }}
                                imgStyle={{ height: 122, width: 122 }}
                                preview={this.props.image ? ("/api/image/get?id=" + this.props.image) : androidBase64}
                                onImagePicked={this.uploadAppIcon.bind(this)}
                            />
                        </GridItem>
                        <GridItem xs={12}>
                            <CustomInput
                                success={googleAppIdRegex.test(this.props.bundle_identifier)}
                                error={!googleAppIdRegex.test(this.props.bundle_identifier)}
                                labelText={
                                    <span>
                                        Application ID <small>(required)</small>
                                    </span>
                                }
                                id="bundle_identifier"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: this.onChangeText.bind(this, "bundle_identifier"),
                                    endAdornment: (
                                        <InputAdornment
                                            position="end"
                                            className={classes.inputAdornment}
                                        >
                                            <VpnKey className={classes.inputAdornmentIcon} />
                                        </InputAdornment>
                                    ),
                                    value: this.props.bundle_identifier,
                                }}
                            />
                        </GridItem>
                        <GridItem xs={12}>
                            <CustomInput
                                success={Boolean(this.props.app_name)}
                                error={!Boolean(this.props.app_name)}
                                labelText={
                                    <span>
                                        App Name <small>(required)</small>
                                    </span>
                                }
                                id="app_name"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: this.onChangeText.bind(this, "app_name"),
                                    value: this.props.app_name,
                                }}
                            />
                        </GridItem>
                        <GridItem xs={12}>
                            <ReactSelect
                                label="Email Notification Recipients"
                                options={
                                    this.state.emails && this.state.emails.length > 0 ?
                                        this.state.emails.map(e => ({ label: e.emailaddress, value: e.id }))
                                        :
                                        [{ label: 'Loading...', value: '' }]
                                }
                                onChange={this.onChangeSelect.bind(this, "email_apps")}
                                isValidNewOption={verifyEmail}
                                onCreateOption={(new_email) => {
                                    Api.get(EmailEndpoints.add, { email: new_email })
                                        .then(({ data }) => {
                                            this.setState({ emails: this.props.email_apps.concat([data]) })
                                            this.props.onChange({ email_apps: this.props.email_apps.concat([{ label: data.emailaddress, value: data.id }]) });
                                        });
                                }}
                                placeholder="No Emails Selected"
                                value={this.props.email_apps}
                                isCreateable
                                isClearable
                                isSearchable
                                isMulti
                                isLoading={!this.state.emails || this.state.emails.length === 0}
                                isDisabled={!this.state.emails || this.state.emails.length === 0}
                            />
                        </GridItem>
                    </GridContainer>
                </DialogContent>
                <DialogActions>
                    <Button style={{ marginRight: 'auto' }} round onClick={this.props.onClose} color="rose" simple>
                        Cancel
                    </Button>
                    {
                        this.state.loading ?
                            <CircularProgress color="secondary" style={{ marginBottom: 5, marginRight: 10 }} />
                            :
                            <Button
                                onClick={this.submit.bind(this)}
                                color="rose"
                                round
                                disabled={!(this.props.bundle_identifier && googleAppIdRegex.test(this.props.bundle_identifier) && this.props.app_name)}
                            >
                                Add App
                                &nbsp;&nbsp;
                                <FontAwesomeIcon icon={faCheck} />
                            </Button>
                    }
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles({ ...extendedFormsStyle, ...style })(AddAndroidAppDialog);